import {Duration} from '../Domain/Duration';
import {Distance} from '../Domain/Distance';

export interface LeaderboardSuggestion {
    category: LeaderboardCategory;
    category_type: LeaderboardCategoryType;
    workout_interval_id: number;
    executed_at: Date;
    season: string;
    duration: Duration;
    distance: Distance;
}

export enum LeaderboardCategoryType {
    Distance = 'distance',
    Time = 'time',
}

export enum LeaderboardCategory {
    Distance100 = 'distance-100',
    Distance250 = 'distance-250',
    Distance500 = 'distance-500',
    Distance1000 = 'distance-1000',
    Distance2000 = 'distance-2000',
    Distance5000 = 'distance-5000',
    Distance6000 = 'distance-6000',
    Distance10000 = 'distance-10000',

    Time60 = 'time-60',
    Time1800 = 'time-1800',
    Time3600 = 'time-3600',
}
